module.exports = __webpack_public_path__ + "assets/img/tab-cover4-cdc046b9.jpg";